import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { NotificationsService } from 'src/app/services/notifications/notifications.service';

interface Notification {
  id: number;
  created: Date;
  outlet_id: number;
  user_id: number;
  type: string;
  heading: string;
  body: string;
  read_receipt: number;
  visible: number;
  link: string;
}

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit {
  constructor(
    private router: Router,
    private notificationsService: NotificationsService,
    private api: ApiService
  ) {
    this.notificationsService.notificationsSubject.subscribe(
      (notifications) => {
        this.NOTIFICATIONS = notifications.slice(0, 6);

        // Calculate unread count from the complete list
        this.unreadCount = notifications.filter(
          (notification) => notification.read_receipt === 0
        ).length;
        console.log('Unread Count:', this.unreadCount); // Log the unread count for debugging
      }
    );
    this.notificationsService.notificationLightSubject.subscribe((trigger) => {
      this.notificationLight = trigger;
    });
    this.notificationsService.bellTriggerSubject.subscribe((trigger) => {
      this.bellTrigger = trigger;
    });
  }
  NOTIFICATIONS: any[] = [];
  bellTrigger = false;
  unreadCount = 0;
  notificationLight = false;

  notifications$: any;

  ngOnInit(): void {
    // Fetch initial notifications
    this.notificationsService.getNotifications();

    // // get initial notifications
    // this.notifications$ = this.api.getNotifications(0).pipe(
    //   map((res: any) => {
    //     if (res && res.message) {
    //       return res.message.map((notification: any) => {
    //         notification.created = new Date(notification.created);
    //         if (notification.read_receipt == 0) {
    //           this.bellTrigger = true;
    //         }
    //         // add 5 hours 30 mins to this time
    //         // notification.created.setHours(notification.created.getHours() + 5);
    //         // notification.created.setMinutes(
    //         //   notification.created.getMinutes() + 30
    //         // );
    //         return notification;
    //       });
    //     }
    //     return [];
    //   }),
    //   catchError((error) => {
    //     console.log(error);
    //     return of([]);
    //   })
    // );

    // this.listenToNewNotifications();

    // Directly access array; getter will handle the updates
    //     getNotifications(notificationId: number) {
    //   this.api.getNotifications(notificationId).subscribe(
    //     (res: any) => {
    //       if (res && res.message) {
    //         this.NOTIFICATIONS = res.message;
    //       }
    //     },
    //     (error) => {
    //       console.log(error);
    //     },
    //     () => {
    //       console.log(this.NOTIFICATIONS);
    //       // convert created string to created date
    //       this.NOTIFICATIONS.forEach((notification) => {
    //         notification.created = new Date(notification.created);
    //         if (notification.read_receipt == 0) {
    //           this.bellTrigger = true;
    //         }
    //         // add 5 hours 30 mins to this time
    //         // notification.created.setHours(notification.created.getHours() + 5);
    //         // notification.created.setMinutes(
    //         //   notification.created.getMinutes() + 30
    //         // );
    //       });
    //     }
    //   );
    // }
    // }
  }

  navigateToNotification(notificationId: number) {
    this.router.navigate(['/notifications', notificationId]);
  }
  openAllNotifications() {
    this.router.navigate(['/notifications']);
  }

  listenToNewNotifications() {
    //   this.wss.listen('notification').subscribe((data: any) => {
    //     if (data) {
    //       if (data.created) {
    //         data.created = new Date(data.created);
    //       }
    //       this.NOTIFICATIONS.unshift(data);
    //       this.bellTrigger = true;
    //       this.playNotificationSound();
    //     }
    //   });
  }

  // playNotificationSound() {
  //   const audio = new Audio('assets/sounds/notification-sound.mp3');
  //   audio
  //     .play()
  //     .then(() => {
  //       // Sound played successfully
  //     })
  //     .catch((error) => {
  //       // Handle error, such as the user interaction requirement
  //       console.error('Failed to play notification sound:', error);
  //     });
  // }
  markAllAsRead(event: Event) {
    event.preventDefault();
    const allNotifications =
      this.notificationsService.notificationsSubject.getValue();
    const unreadNotifications = allNotifications.filter(
      (notification) => notification.read_receipt === 0
    );
    if (unreadNotifications.length > 0) {
      const markAsReadCalls = unreadNotifications.map((notification) =>
        this.api.changeReadStatus(notification.id, 1)
      );

      forkJoin(markAsReadCalls).subscribe(
        (res) => {
          unreadNotifications.forEach((notification) => {
            notification.read_receipt = 1;
          });
          this.notificationsService.notificationsSubject.next(allNotifications);
          this.notificationsService.notificationLightSubject.next(false);
          console.log('All notifications marked as read.');
        },
        (error) => {
          console.log('Error marking notifications as read:', error);
        }
      );
    }
  }
}
